const DEFAULT_APP_NAME = 'DeepSynthesis'
const DEFAULT_APP_SUB_NAME = 'AI Engineered for Enterprise'

/**
 * Product display name — same source as the main UI `getAppName()`.
 * Prefer the Auth API value (Admin catalog `VITE_APP_NAME`), then the Vite env, then DeepSynthesis.
 */
export function getAppName(fromApi?: string | null): string {
  const apiName = fromApi == null ? '' : String(fromApi).trim()
  if (apiName) {
    return apiName
  }
  const envName = String(import.meta.env.VITE_APP_NAME ?? '').trim()
  return envName || DEFAULT_APP_NAME
}

/**
 * Tagline under the product name — same source as the main UI `getAppSubName()`.
 * Prefer the Auth API value (Admin catalog `VITE_APP_SUB_NAME`), then the Vite env,
 * then AI Engineered for Enterprise.
 */
export function getAppSubName(fromApi?: string | null): string {
  const apiName = fromApi == null ? '' : String(fromApi).trim()
  if (apiName) {
    return apiName
  }
  const envName = String(import.meta.env.VITE_APP_SUB_NAME ?? '').trim()
  return envName || DEFAULT_APP_SUB_NAME
}
